import { MAX_TWO_DECIMALS_REGEX, numberErrorMessage, requiredErrorMessage } from 'constants/constants';
import * as Yup from 'yup';

const decimalPrecisionTest = (fieldName: string) => Yup.number().defined()
    .test('decimal-precision', `${fieldName} must have at most 2 decimal places`,
        value => !value || MAX_TWO_DECIMALS_REGEX.test(value.toString()));

export const liveStockCommodityValidationSchema = Yup.object({
    name: Yup.string().required(requiredErrorMessage).typeError(requiredErrorMessage),
    year: Yup.number().required(requiredErrorMessage).typeError(numberErrorMessage),
    revenuePercentage: Yup.number().required(requiredErrorMessage).typeError(numberErrorMessage)
        .min(1, 'Allocation must be at least 1%')
        .max(100, 'Allocation cannot exceed 100%')
        .concat(decimalPrecisionTest('Allocation'))
});